import React from 'react'
import { ArrowForwardIos } from '@mui/icons-material';
import {ReactComponent as Changeicon} from '../../assets/new-icons/change.svg';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function ChooseBox() {
    const navigate = useNavigate()
    const idGroup = useSelector((user) => user.user.idGruppo)
    const priceKwhPos = useSelector((user) => user.user.nuoviDatiContratto.mono_positivo)
    const priceKwhNeg = useSelector((user) => user.user.nuoviDatiContratto.mono_negativo)
    return (
        <div className="chooseBox">
            <p className='label'>Scegli il piano più adatto a te</p>
            <p className='sulLabel'>Ogni piano è pensato per adattarsi alle tue esigenze di ricarica e risparmio. Clicca sul pulsante e scoprili tutti!</p>
            <p className='sulLabel bold'>Scopri come pagare il nostro miglior prezzo al kWh tutto incluso!</p>
            <div className="choosePlanBox">
                <p className='price'>
                    {
                        parseFloat(priceKwhPos).toFixed(2).replace(/\./g, ",")
                    }
                <span>€/kWh</span></p>
                <div className="circle green"></div>
                <div className="circle orange"></div>
                <div className="circle red"></div>
            </div>
            <div className="discoverPlans" onClick={() => navigate('/enrica/scegli-piano')}>
                <Changeicon className='changeIcon arrowchange'/>
                <p>Scopri i nostri piani</p>
                <ArrowForwardIos className='arrow'/>
            </div>
        </div>
    )
}

export default ChooseBox
